var e=6e4,r=36e5,a=1e3;export{r as millisecondsInHour,e as millisecondsInMinute,a as millisecondsInSecond};
